import Image from 'next/image';
import Corks from '../commons/Corks';

interface Props {
  id: number;
  imageUrl: string;
  points: number;
  name: string;
  isAuth: boolean;
}

const CatalogItem = (props: Props): JSX.Element => (
  <article className="tw-flex tw-flex-col tw-h-full tw-group">
    <div className="tw-relative tw-w-full tw-aspect-square tw-mb-2">
      <Image
        fill
        src={props.imageUrl}
        alt={props.name}
        className="tw-rounded-lg"
      />
    </div>
    <div>
      <h2 className="tw-text-lg tw-mb-0 tw-font-bold group-hover:tw-underline tw-underline-offset-2">
        {props.name}
      </h2>
      {props.isAuth && (
        <Corks loyaltyPoints={props.points} corkSize="4" numberSize="lg" />
      )}
    </div>
  </article>
);
export default CatalogItem;
